import { useState } from "react";
import type { BingoGame } from "bingo/types/bingo-game.model";
import type { BingoTemplate } from "bingo/types/bingo-template.model";
import { useAddBingoGameMutation } from "bingo/api/bingo-game.api";
import { TextInput, Button, Box, LoadingOverlay } from "@mantine/core";
import { useNavigate } from "react-router-dom";

interface CreateGameHelperProps {
  bingoTemplate: BingoTemplate;
}

export function CreateGameTempHelper({ bingoTemplate }: CreateGameHelperProps) {
  const [name, setName] = useState("");
  const [addBingoGame, { isLoading }] = useAddBingoGameMutation();
  const navigate = useNavigate();

  const handleCreateGame = () => {
    if (!name.trim()) return;

    const bingoGame: BingoGame = {
      access: {
        entity: bingoTemplate.access.entity || "",
        organization: bingoTemplate.access.organization,
        section: bingoTemplate.access.section || "",
      },
      id: `game-${Date.now()}`,
      name,
      beginDate: new Date().toISOString(),
      endDate: new Date(Date.now() + 3600000).toISOString(), // 1 hour later
      creationTime: new Date().toISOString(),
      status: "NOT_STARTED",
      drawNumbersList: [],
      gridQRCodeAccess: "",
      bingoTemplateId: bingoTemplate.id,
      bingoTemplateSnapshot: bingoTemplate,
    };

    addBingoGame(bingoGame);
    navigate(`../bingogames`);
  };

  return (
    <>
      {isLoading ? (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <div className="spinner-border" role="status">
            <LoadingOverlay visible={true} overlayOpacity={100} />
          </div>
        </div>
      ) : null}
      <Box className="w-full">
        <TextInput
          label="Bingo Game Name"
          placeholder="Enter game name"
          value={name}
          onChange={(event) => setName(event.currentTarget.value)}
          className="w-full"
        />
        <Button
          mt="md"
          className="bg-button-admin disabled:opacity-75"
          onClick={handleCreateGame}
        >
          Create Bingo Game
        </Button>
      </Box>
    </>
  );
}
